// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_down.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__label___rytq1 {
}

.styles__arrow___XANOC {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: left;
  background-repeat: no-repeat;
  padding-right: 10px;
  display: block;
  height: 42px;
}
.styles__select___wlK9N {
  /* margin-top: 10px; */
  width: 50%;
}
.styles__dynamicInput___juJxo {
  display: flex;
  flex-direction: column;

  padding-bottom: 10px;
}
.styles__dynamicInput___juJxo input,
  .styles__dynamicInput___juJxo .Select-control {
    width: calc(99.9% * 1/2 - (30px - 30px * 1/2));
  }
.styles__dynamicInput___juJxo input:nth-child(1n),
  .styles__dynamicInput___juJxo .Select-control:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
  }
.styles__dynamicInput___juJxo input:last-child,
  .styles__dynamicInput___juJxo .Select-control:last-child {
    margin-right: 0;
  }
.styles__dynamicInput___juJxo input:nth-child(2n),
  .styles__dynamicInput___juJxo .Select-control:nth-child(2n) {
    margin-right: 0;
    float: right;
  }
.styles__dynamicInput___juJxo input:nth-child(2n + 1),
  .styles__dynamicInput___juJxo .Select-control:nth-child(2n + 1) {
    clear: both;
  }
@media (max-width: 960px) {
.styles__dynamicInput___juJxo input,
  .styles__dynamicInput___juJxo .Select-control {
      width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
  }
.styles__dynamicInput___juJxo input:nth-child(1n),
  .styles__dynamicInput___juJxo .Select-control:nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
  }
.styles__dynamicInput___juJxo input:last-child,
  .styles__dynamicInput___juJxo .Select-control:last-child {
      margin-right: 0;
  }
.styles__dynamicInput___juJxo input:nth-child(1n),
  .styles__dynamicInput___juJxo .Select-control:nth-child(1n) {
      margin-right: 0;
      float: right;
  }
.styles__dynamicInput___juJxo input:nth-child(1n + 1),
  .styles__dynamicInput___juJxo .Select-control:nth-child(1n + 1) {
      clear: both;
  }
    }

.styles__dynamicInput___juJxo .Select-control {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  border-radius: 3px;
  cursor: pointer;
}

.styles__dynamicInput___juJxo.Select.is-focused:not(.is-open) > .Select-control {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  box-shadow: none;
  outline: none;
}

.styles__dynamicInput___juJxo .Select-value {
  background-color: transparent;
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
}

.styles__dynamicInput___juJxo.Select.has-value.Select--single
      > .Select-control
      .Select-value
      .Select-value-label {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  line-height: 42px;
}

.styles__dynamicInputOption___ubMyL,
.styles__dynamicInput___juJxo .Select-placeholder,
.styles__dynamicInputOption___ubMyL.is-focused {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  line-height: 42px;
}

.styles__formItem___bE9R2 {
}

.styles__select___wlK9N {
}
`, "",{"version":3,"sources":["webpack://./universal/components/DynamicSelect/styles.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;EACE,yDAAiD;EACjD,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;AACA;EAEE,sBAAsB;EACtB,UAAU;AACZ;AACA;EAEE,aAAa;EACb,sBAAsB;;EAWtB,oBAAoB;AACtB;AAVE;;IAEE,8CAAgB;EAKlB;AAPA;;IAEE,WAAgB;IAAhB,kBAAgB;IAAhB,WAAgB;EAKlB;AAPA;;IAEE,eAAgB;EAKlB;AAPA;;IAEE,eAAgB;IAAhB,YAAgB;EAKlB;AAPA;;IAEE,WAAgB;EAKlB;AAHE;AAJF;;MAKI,8CAAkB;EAEtB;AAPA;;MAKI,WAAkB;MAAlB,kBAAkB;MAAlB,WAAkB;EAEtB;AAPA;;MAKI,eAAkB;EAEtB;AAPA;;MAKI,eAAkB;MAAlB,YAAkB;EAEtB;AAPA;;MAKI,WAAkB;EAEtB;IADE;;AAMJ;EACE,8DAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8DAA6B;EAC7B,0DAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,0DAAwB;EACxB,mDAAa;AACf;;AAEA;;;;EAME,mDAAa;EACb,iBAAiB;AACnB;;AAEA;;;EAGE,mDAAa;EACb,iBAAiB;AACnB;;AAEA;AAEA;;AAEA;AAEA","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: 'styles/colors.css';\n@value gtBlue, gtBlueDark, gtBlueLight, gtGray from helpers;\n\n.label {\n  composes: label from helpers;\n}\n\n.arrow {\n  background-image: url('styles/img/icon_down.png');\n  background-position: left;\n  background-repeat: no-repeat;\n  padding-right: 10px;\n  display: block;\n  height: 42px;\n}\n.select {\n  composes: select from helpers;\n  /* margin-top: 10px; */\n  width: 50%;\n}\n.dynamicInput {\n  composes: formItem from helpers;\n  display: flex;\n  flex-direction: column;\n\n  input,\n  :global(.Select-control) {\n    lost-column: 1/2;\n\n    @media (max-width: 960px) {\n      lost-column: 1 / 1;\n    }\n  }\n\n  padding-bottom: 10px;\n}\n\n.dynamicInput :global(.Select-control) {\n  border: 1px solid gtGray;\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n.dynamicInput:global(.Select.is-focused:not(.is-open) > .Select-control) {\n  background-color: gtBlueLight;\n  border-color: gtBlue;\n  box-shadow: none;\n  outline: none;\n}\n\n.dynamicInput :global(.Select-value) {\n  background-color: transparent;\n  border-color: gtBlueDark;\n  color: gtBlue;\n}\n\n.dynamicInput:global(\n    .Select.has-value.Select--single\n      > .Select-control\n      .Select-value\n      .Select-value-label\n  ) {\n  color: gtBlue;\n  line-height: 42px;\n}\n\n.dynamicInputOption,\n.dynamicInput :global(.Select-placeholder),\n.dynamicInputOption:global(.is-focused) {\n  color: gtBlue;\n  line-height: 42px;\n}\n\n.formItem {\n  composes: formItem from helpers;\n}\n\n.select {\n  composes: select from helpers;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `'styles/colors.css'`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"label": `styles__label___rytq1 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["label"]}`,
	"arrow": `styles__arrow___XANOC`,
	"select": `styles__select___wlK9N ${___CSS_LOADER_ICSS_IMPORT_0___.locals["select"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["select"]}`,
	"dynamicInput": `styles__dynamicInput___juJxo ${___CSS_LOADER_ICSS_IMPORT_0___.locals["formItem"]}`,
	"dynamicInputOption": `styles__dynamicInputOption___ubMyL`,
	"formItem": `styles__formItem___bE9R2 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["formItem"]}`
};
export default ___CSS_LOADER_EXPORT___;
